<h2 mat-dialog-title>{{ data?.title }}</h2>
<mat-dialog-content class="content-container">
  <quill-view-html [content]="data.content" theme="snow" [sanitize]="true"></quill-view-html>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="primary">Close</button>
</mat-dialog-actions>
